export type AssignmentRow = {
  id: number;
  employeeCode: string;
  name: string;
};

export type ProjectSummary = {
  id: number;
  projectName: string;
};

export type AssignmentGetResponse = {
  items: AssignmentRow[];
  project: ProjectSummary;
};

export const EmptyProjectSummary: ProjectSummary = {
  id: 0,
  projectName: '',
};

export const EmptyAssignmentGetResponse: AssignmentGetResponse = {
  items: [],
  project: EmptyProjectSummary,
};
